<mat-expansion-panel [togglePosition]="'before'" (opened)="opened()">
    <mat-expansion-panel-header>
        <mat-panel-title>
            Employer Labour Condition Statements
        </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="p-4">
        <form [formGroup]="EmpLCS">

            <div class="row my-3">
                <div class="col-md-12 d-flex justify-content-end" *ngIf="isDuplicateLCA">
                    <button class="clear-data-button" (click)="clearData()">
                        <i class="fa fa-repeat"></i> Clear Data
                    </button>
                </div>
            </div>

            <div class="form-group col-md-12">
                <!-- <div class="row form-group col-md-12 pl-0 pt-3"> -->
                <!-- <p-checkbox name="groupname" value="petitioner" label="Petitioner" [(ngModel)]="digiSignarture.requiredFor"></p-checkbox>
            <p-checkbox name="groupname" value="attorney" label="Attorney" [(ngModel)]="digiSignarture.requiredFor" class="ml-3"></p-checkbox> -->


                <P>In order for your application to be processed, you MUST read Section G of the
                    Form ETA-9035CP - General Instructions for the 9035 & 9035E
                    under the heading “Employer Labor Condition Statements” and agree to all four (4)
                    labor condition statements summarized below
                </P> <br>
                <p>
                    <b>1. Wages: </b>Wages: The employer shall pay nonimmigrant workers at least
                    the prevailing wage or the employer’s actual wage, whichever is higher,
                    and pay for non-productive time. The employer shall offer nonimmigrant workers
                    benefits and eligibility for benefits provided as compensation for services on
                    the same basis as the employer offers to U.S. workers.
                    The employer shall not make deductions to recoup a business expense(s) of the
                    employer including Lawfirm fees and other costs connected to the performance
                    of H-1B, H-1B1, or E-3program functions which are required to be performed by
                    the employer.
                    This includes expenses related to the
                    preparation and filing ofthis LCA and related visa petition information.
                    20 CFR 655.731;
                </p>
                <br>

                <p> <b>2. Working Conditions: </b>The employer shall provide working conditions for
                    nonimmigrants which will not adversely affect the working conditions of workers
                    similarly employed.
                    The employer’s obligation regarding working conditions shall extend for the
                    duration of the validity period of the certified LCA or the period during which the worker(s)
                    working pursuant to this LCA is employed by the employer, whichever is longer.
                    20 CFR 655.732 </p>
                <br>


                <p> <b>3. Strike, Lockout, or Work Stoppage:</b> At the time of filing this LCA,
                    the employer is not involved in a strike, lockout,
                    or work stoppage inthe course of a labor dispute in the occupational
                    classification in the area(s) of intended employment.
                    The employer will notify the Department of Labor within 3 days of the occurrence of a
                    strike or lockout in the occupation, and in that event the
                    LCA will not be used tosupport a petition filing with the U.S.
                    Citizenship and Immigration Services (USCIS) until the DOL Employment and
                    Training Administration
                    ( ETA) determines that the strike or lockout has ended. 20 CFR 655.733; an </p>
                <br>

                <p> <b>4. Notice:</b> Notice of the LCA filing was provided no more than 30 days
                    before the filing of this LCA or will be provided on the day this LCA isfiled
                    to the bargaining representative in the occupation and area of
                    intended employment, or if there is no bargaining representative,
                    to workers in the occupation at the place(s) of employment either by electronic
                    or physical posting. This notice was or will be posted for atotal period of 10 days,
                    except that if employees are provided individual direct notice by e-mail,
                    notification need only be given once.
                    A copy of the notice documentation will be maintained in the employer’s
                    public access file.
                    A copy of this LCA will be provided to each nonimmigrant worker
                    employed pursuant to the LCA. The employer shall, no later than the date the
                    worker(s) report to work at theplace(s) of employment, provide a signed
                    copy of the certified LCA to the worker(s) working pursuant to this LCA.
                    20 CFR 655.734. </p>
                <br>

                <span class=" col-md-12">

                    <mat-checkbox class="label-cls" name="cbEmp" formControlName="cbEmp"
                        (change)="checkCheckBoxvalueEmp($event)">
                    </mat-checkbox>

                    <b>
                        I have read and agree
                    </b>
                    to Labor Condition Statements 1, 2, 3, and 4 above and as fully
                    explained in Section G of the Form ETA-9035CP – General Instructions for the 9035 & 9035E
                    and the Department’s
                    regulation sat 20 CFR 655 .
                </span>
            </div>
        </form>
    </div>
</mat-expansion-panel>

<!-- Confirm Reset Modal -->
<p-confirmDialog id="confirm-reset-modal" [style]="{width: '35vw'}"></p-confirmDialog>